export default {
  add(_state, payload) {
    this.state.account.current.experiments.push(payload);
  },
  update(_state, payload) {
    const index = this.state.account.current.experiments.findIndex(
      (experiment) => experiment.id == payload.id
    );
    this.state.account.current.experiments.splice(index, 1, payload);
  },
  delete(_state, payload) {
    const index = this.state.account.current.experiments.findIndex(
      (experiment) => experiment.id == payload
    );
    this.state.account.current.experiments.splice(index, 1);
  },
};
